import { useTranslation } from "react-i18next";

import { ReviewVisitTableHeaderCell } from "../../../../../components/ReviewVisitTable";

export function FinalReportWeatherCardTableHeader() {
    const { t } = useTranslation("project");

    return (
        <>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.finalReportRoute.finalReportWeatherCardTableHeader.conditions")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.finalReportRoute.finalReportWeatherCardTableHeader.startForm")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.finalReportRoute.finalReportWeatherCardTableHeader.endForm")}
            </ReviewVisitTableHeaderCell>
        </>
    );
}
